import { Stack, Typography } from '@mui/material';
import { memo } from 'react';

import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

export const SelectionError = memo(() => (
  <Stack
    my={2}
    justifyContent="center"
    alignItems="center"
    flexDirection="row"
    gap={0.5}
  >
    <Icon
      name="actions-b2b-error-circle"
      size={20}
      color={NEW_COLORS.SEMANTICS.ERROR[600]}
    />
    <Typography variant="text">
      Não foi possível carregar os contratos.
    </Typography>
  </Stack>
));
